export default __webpack_public_path__ + "img/rule45back-469ddc3d.png";